import React from 'react';
import PropTypes from 'prop-types';

export default function PadIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18.509 17.126'
      className={className}
    >
      <g id='Grupo_151186' data-name='Grupo 151186' transform='translate(24143.691 15719.323)'>
        <rect
          id='Retângulo_1236'
          data-name='Retângulo 1236'
          width='3.52'
          height='6.285'
          transform='translate(-24136.18 -15708.482)'
          fill={fill}
        />
        <path
          id='Caminho_11779'
          data-name='Caminho 11779'
          d='M237.17,760.3l-9.27,9.27h1.634V777.4h4.682v-7.448h5.876V777.4h4.714V769.57h1.6Z'
          transform='translate(-24371.592 -16479.623)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

PadIcon.defaultProps = {
  fill: '#cacaca',
  width: 18.509,
  height: 17.126
};

PadIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
